// extracted by mini-css-extract-plugin
export default {"mainWrapper":"LoaderFullPage_mainWrapper__b1-34"};